import { BASE_URL } from '../config/api';

interface VersionInfo {
  version: string;
  buildTimestamp: number;
  serverTime: number;
}

// Store the last checked server version to avoid unnecessary reloads
let lastCheckedServerVersion: string | null = null;



export const versionService = {
  /**
   * Check if there's a newer version of the app available
   * @returns Promise resolving to true if a newer version is available, false otherwise
   */
  async checkForNewVersion(): Promise<boolean> {
    try {
      const response = await fetch(`${BASE_URL}/api/version`);
      if (!response.ok) {
        throw new Error(`Failed to fetch version info: ${response.status} ${response.statusText}`);
      }
      
      const versionInfo: VersionInfo = await response.json();
      
      // If this is our first check, store the server version
      if (lastCheckedServerVersion === null) {
        lastCheckedServerVersion = versionInfo.version;
        return false; // First load, no need to reload
      }
      
      // If the server version has changed since our last check, a new version is available
      if (versionInfo.version !== lastCheckedServerVersion) {
        lastCheckedServerVersion = versionInfo.version;
        return true;
      }

      return false;
    } catch (error) {
      console.error('Error checking for new version:', error);
      return false;
    }
  }
};
